<template>
    <div>
        <div>
            {{ currentDropdown }}
            <input id="ddown1-value" type="hidden" :value="selected" ref="button" />
            <b-dropdown class="dropdown button--select" :size="size" id="ddown1" :text="currentDropdown.text" variant="btn" role="listbox" @hidden="onHidden">
                <aha-dropdown-button v-for="option in options" v-bind:key="option.value" @click="selected = option.value">{{ option.text }}</aha-dropdown-button>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
    import DropdownButton from '@/components/aha-dropdown-button';

    export default {
        data() {
            return {
                selected: null,
                options: [
                    {
                        value: null,
                        text: 'Select Option'
                    },
                    {
                        value: 'a',
                        text: 'Option 1'
                    },
                    {
                        value: 'b',
                        text: 'Option 2'
                    },
                    {
                        value: 'C',
                        text: 'Option 3'
                    },
                    {
                        value: 'd',
                        text: 'Option 4'
                    }
                ]
            }
        },
        props: {
            size: {
                type: String,
                default: ''
            }
        },
        computed: {
            currentDropdown: function () {
                return this.options.find(option => option.value === this.selected);
            }
        },
        methods: {
            onHidden() {
                const button = this.$el.querySelector('[aria-haspopup]');

                this.$nextTick(() => {
                    button.focus();
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// demo/ui-kit/dropdown.vue